// 公用埋点
export default {
  HELPCENTER_SEARCH: {// 完成
    key: 'helpcenter_search',
    label: '搜索按钮'
  },
  HELPCENTER_ALLVIDEOS: {// 完成
    key: 'helpcenter_allvideos',
    label: '全部视频按钮'
  },
  HELPCENTER_VIDEOLIST: {// 完成
    key: 'helpcenter_videolist',
    label: '视频模块链接分别埋点'
  },
  HELPCENTER_ALLMANUALS: {// 完成
    key: 'helpcenter_allmanuals',
    label: '全部手册'
  },
  HELPCENTER_MANUALBUTTON: {// 完成
    key: 'helpcenter_manualbutton',
    label: '手册各标签按钮分别埋点'
  },
  HELPCENTER_ALLPROBLEM: {// 完成
    key: 'helpcenter_allproblem',
    label: '全部问题按钮'
  },
  HELPCENTER_COMMONPROBLEM: {// 完成
    key: 'helpcenter_commonproblem',
    label: '首页常见问题整体分别埋点'
  },
  HELPCENTER_ONLINESERVICE: {// 完成
    key: 'helpcenter_onlineservice',
    label: '在线客服按钮'
  },
  HELPCENTER_INQUIRYFORM: {// 完成
    key: 'helpcenter_Inquiryform',
    label: '咨询单按钮'
  },
  // 手册列表
  HELPCENTER_MANUAL_MENU: {
    key: 'helpcenter_manual_menu',
    label: '手册列表-左侧菜单分别埋点'
  },
  HELPCENTER_MANUAL_LIST: {
    key: 'helpcenter_manual_list',
    label: '手册列表-列表按照手册名称分别埋点'
  },
  // 视频列表
  HELPCENTER_VIDEO_MENU: {
    key: 'helpcenter_video_menu',
    label: '视频列表-左侧菜单分别埋点'
  },
  HELPCENTER_VIDEO_LIST: {
    key: 'helpcenter_video_list',
    label: '视频列表-列表按照手册名称分别埋点'
  },
  // 常见问题列表
  HELPCENTER_PROBLEM_MENU: {
    key: 'helpcenter_problem_menu',
    label: '常见问题列表-左侧菜单分别埋点'
  },
  HELPCENTER_PROBLEM_LIST: {
    key: 'helpcenter_problem_list',
    label: '常见问题列表-列表按照手册名称分别埋点'
  },
  // 手册详情页
  HELPCENTER_MANUAL_DOWNLOAD: {
    key: 'helpcenter_manual_download',
    label: '各手册下载按钮分别埋点'
  },
  // 问题详情页
  HELPCENTER_PROBLEM_LIKE: {
    key: 'helpcenter_problem_like',
    label: '点赞按钮'
  },
  HELPCENTER_PROBLEM_UNLIKE: {
    key: 'helpcenter_problem_unlike',
    label: '点踩按钮'
  }

}
